import { type SessionStore, getSessionManager } from '@/utils/session';
import { BaseHttpAgent } from '@marpla/core/agent/base-http.agent';

export class HttpAgent extends BaseHttpAgent {
  get session$(): SessionStore {
    this._session$ ||= getSessionManager();

    return this._session$;
  }
}
